const career = {
  tr: {
    departments: [
      ["Ön Büro", "frontDesk"],
      ["F&B", "foodAndBeverage"],
      ["House Keeping", "houseKeeping"],
      ["Mutfak", "kitchen"],
      ["Muhasebe ve İnsan kaynakları", "accountingHr"],
      ["SPA & Wellness", "spa"],
    ],
    frontDesk: [
      "Resepsiyon Görevlisi",
      "Concierge",
      "Gece Görevlisi",
      "Misafir Hizmetleri Müdürü",
      "Rezervasyon Görevlisi",
      "Bellboy/Portör",
      "Telefon Operatörü",
      "Şoför",
    ],
    foodAndBeverage: [
      "F&B Müdürü",
      "Restoran Müdürü",
      "Banket Müdürü",
      "Barmen",
      "Garson/Bayan Garson",
      "Oda Servisi Görevlisi",
      "Sommelier",
      "Barista",
      "Catering satış müdürleri",
    ],
    houseKeeping: [
      "House Keeping Müdürü",
      "House Keeping Görevlisi",
      "Oda Görevlisi/Temizlikçi",
      "Çamaşırhane Görevlisi",
      "Ortak Alan Görevlisi",
      "Çarşaf Odası Görevlisi",
      "Temizlik Görevlisi Yönlendiricisi",
      "Kat Görevlisi",
      "Derin Temizlik Uzmanı",
    ],
    kitchen: [
      "Executive Şef",
      "Sous Şef",
      "Chef de Partie (İstasyon Şefi)",
      "Line Cook",
      "Pasta Şefı",
      "Mutfak Görevlisi/Bulaşıkçı",
      "Mutfak Müdürü",
      "Hazırlık Şefi",
    ],
    accountingHr: [
      "İK Müdürü/Direktörü",
      "İşe Alım Uzmanı",
      "Eğitim ve Gelişim Uzmanı",
      "Sağlık ve Güvenlik Görevlisi",
      "Kontrolör/Baş Muhasebeci",
      "Borçlar Hesapları Memuru",
      "Finansal Analist",
    ],
    spa: [
      "Spa Direktörü",
      "Spa Müdürü",
      "Spa Resepsiyonisti",
      "Masaj Terapisti",
      "Estetisyen",
      "Nail Technician",
      "Spa Terapisti/Vücut Tedavi Uzmanı",
      "Yoga Eğitmeni",
      "Fitness Eğitmeni",
    ],
  },
  en: {
    departments: [
      ["Front Desk", "frontDesk"],
      ["Food & Beverage", "foodAndBeverage"],
      ["House Keeping", "houseKeeping"],
      ["Kitchen", "kitchen"],
      ["Accounting & HR", "accountingHr"],
      ["SPA & Wellness", "spa"],
    ],
    frontDesk: [
      "Front Desk Agent",
      "Concierge",
      "Night Auditor",
      "Guest Services Manager",
      "Reservation Agent",
      "Bellhop/Porter",
      "Telephone Operator",
      "Driver",
    ],
    foodAndBeverage: [
      "Food and Beverage Manager",
      "Restaurant Manager",
      "Banquet Manager",
      "Bartender",
      "Server/Waiter/Waitress",
      "Room Service Attendant",
      "Sommelier",
      "Barista",
      "Catering sales managers",
    ],
    houseKeeping: [
      "Housekeeping Manager",
      "Housekeeping Supervisor",
      "Room Attendant/Housekeeper",
      "Laundry Attendant",
      "Public Area Attendant",
      "Linen Room Attendant",
      "Housekeeping Dispatcher",
      "Floor Supervisor",
      "Deep Cleaning Specialist",
    ],
    kitchen: [
      "Executive Chef",
      "Sous Chef",
      "Chef de Partie (Station Chef)",
      "Line Cook",
      "Pastry Chef",
      "Kitchen Steward/Dishwasher",
      "Kitchen Manager",
      "Prep Cook",
    ],
    accountingHr: [
      "HR Manager/Director",
      "Recruiter",
      "Training and Development Specialist",
      "Health and Safety Officer",
      "Controller/Chief Accountant",
      "Accounts Payable Clerk",
      "Financial Analyst",
    ],
    spa: [
      "Spa Director",
      "Spa Manager",
      "Spa Receptionist",
      "Massage Therapist",
      "Esthetician",
      "Nail Technician",
      "Spa Therapist/Body Treatment Specialist",
      "Yoga Instructor",
      "Fitness Instructor",
    ],
  },
};

export default career;
